import { create } from 'zustand'
import type { ActiveTab } from '../components/WorkFullscreen'

interface WorkFullscreenState {
  isFullscreen: boolean
  activeTab: ActiveTab
  openFullscreen: () => void
  openProjectsTab: () => void
  setActiveTab: (tab: ActiveTab) => void
  closeFullscreen: () => void
  toggleFullscreen: () => void
}

/**
 * Controls the unified Tasks/Projects fullscreen overlay. Despite the name,
 * this state is shared by both surfaces — it owns which tab is active.
 */
export const useWorkFullscreen = create<WorkFullscreenState>((set) => ({
  isFullscreen: false,
  activeTab: 'tasks',
  openFullscreen: () => set({ isFullscreen: true, activeTab: 'tasks' }),
  openProjectsTab: () => set({ isFullscreen: true, activeTab: 'projects' }),
  setActiveTab: (tab) => set({ activeTab: tab }),
  closeFullscreen: () => set({ isFullscreen: false, activeTab: 'tasks' }),
  toggleFullscreen: () => set((state) => ({ isFullscreen: !state.isFullscreen, activeTab: 'tasks' })),
}))
